'use client';
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState, useEffect } from 'react';
import '@/styles/components/global/nav.css';

const Nav = () => {
  const pathname = usePathname();
  
  const sections = [
    { name: 'Home', link: '/' },
    { name: 'About', link: '/about' },
    { name: 'Contact', link: '/contact' }
  ];

  const [isMobile, setIsMobile] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200);
    
    const checkMobile = () => setIsMobile(window.innerWidth <= 1200);
    const updateVisibility = () => {
      if (window.innerWidth <= 768) {
        setMenuVisible(document.body.classList.contains('viewing'));
      }
    };

    checkMobile();
    updateVisibility();

    window.addEventListener('resize', checkMobile);
    const observer = new MutationObserver(updateVisibility);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => {
      window.removeEventListener('resize', checkMobile);
      observer.disconnect();
    };
  }, []);

  const checkMenu = () => {
    const isOpen = document.body.classList.contains('viewing');
    const escEvent = new KeyboardEvent("keydown", {
      key: "Escape",
      code: "Escape",
      keyCode: 27,
      which: 27,
      bubbles: true,
    });

    if (isOpen) document.dispatchEvent(escEvent);
  }

  return (
    <nav id="nav-main" className="nav-main" aria-hidden={isMobile ? !menuVisible : undefined}>
      <ul role="list">
        {sections.map((section) => {
          return (
            <li key={section.name} data-section={section.name}>
              <Link 
                onClick={checkMenu}
                href={`${section.link}`} 
                className={pathname === section.link ? "active" : ""}
              >
                {section.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
